import { Auth0Service } from "../service/auth0.service";
import { getCookie } from "../../data/utils/cookie-utils";
import {
  checkAndRefreshToken,
  initActivityTracker,
  refreshIntervals,
  stopTokenRefreshChecker,
} from "./helper-polling.utils";
import { validateTokenConfig } from "./validateRefreshToken";

const DEFAULTS = {
  pollIntervalMinutes: 2,
  userInactiveHours: 2,
  accessTokenExpiryHours: 0.25,
  refreshBeforeExpiryMinutes: 5,
};

// ----------------- Session Expired -----------------
export function sessionExpired() {
  console.log("[Session] Expired → redirecting to logout");
  stopTokenRefreshChecker();
  const tenantCode = getCookie('tenant_code') || 'platform';
  window.location.href = `/${tenantCode}/logout`;
}

// ----------------- Init Checker -----------------
export function initRefreshTokenChecker(
  auth: Auth0Service,
  config?: {
    pollIntervalMinutes?: number;
    userInactiveHours?: number;
    accessTokenExpiryHours?: number;
    refreshBeforeExpiryMinutes?: number;
  }
) {
  const key = "global";
  const lastActivityKey = "global_lastActivityTime";

  initActivityTracker();

  if (refreshIntervals[key]) return;

  const {
    pollIntervalMinutes = DEFAULTS.pollIntervalMinutes,
    userInactiveHours = DEFAULTS.userInactiveHours,
    accessTokenExpiryHours = DEFAULTS.accessTokenExpiryHours,
    refreshBeforeExpiryMinutes = DEFAULTS.refreshBeforeExpiryMinutes,
  } = config || {};

  const pollIntervalMs = pollIntervalMinutes * 60 * 1000;
  const userInactiveTimeout = userInactiveHours * 60 * 60 * 1000;
  const refreshThresholdMs = refreshBeforeExpiryMinutes * 60 * 1000;

  const token = getCookie(`access_token`);

  const validConfig = validateTokenConfig({
    pollIntervalMinutes,
    userInactiveHours,
    accessTokenExpiryHours,
    refreshBeforeExpiryMinutes,
    accessToken: token,
  });

  if (!validConfig) return;

  if (!token) {
    setTimeout(() => initRefreshTokenChecker(auth, config), 1000);
    return;
  }

  if (!sessionStorage.getItem(lastActivityKey)) {
    sessionStorage.setItem(lastActivityKey, Date.now().toString());
  }

  console.log(`[Token] ↻ Starting refresh token checker immediately...`);
  checkAndRefreshToken(auth, refreshThresholdMs, accessTokenExpiryHours);

  refreshIntervals[key] = setInterval(() => {
    const lastRaw = sessionStorage.getItem(lastActivityKey);
    const lastActivityTime = lastRaw ? parseInt(lastRaw, 10) : Date.now();

    const inactiveFor = Date.now() - lastActivityTime;
    if (inactiveFor > userInactiveTimeout) {
      console.log(`[Token] Session expired due to inactivity.`);
      sessionExpired();
      return;
    }

    checkAndRefreshToken(auth, refreshThresholdMs, accessTokenExpiryHours);
  }, pollIntervalMs);
}